import React from "react";
import { EditorContent, Editor } from "@tiptap/react";

interface RichTextProps {
  editor: Editor | null;
  id?: string;
  className?: string;
  style?: React.CSSProperties;
}

const RichText: React.FC<RichTextProps> = ({ editor, id, className = "", style }) => {
  if (!editor) {
    return null;
  }

  return (
    <div
      className={`rich-text-editor no-focus-outline ${className}`}
      data-editor-id={id}
      style={style}
    >
      <EditorContent
        editor={editor}
        className="focus:outline-none focus:ring-0 border-0"
        style={{ outline: "none", boxShadow: "none" }}
      />
    </div>
  );
};

export default RichText;
